import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriorityTagComponent } from './priority-tag/priority-tag.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ChangePriorityModalComponent } from './change-priority-modal/change-priority-modal.component';
import { NzButtonModule } from 'ng-zorro-antd/button';

@NgModule({
  declarations: [PriorityTagComponent, ChangePriorityModalComponent],
  imports: [
    CommonModule,
    TranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    NzTagModule,
    NzSelectModule,
    NzFormModule,
    NzButtonModule,
  ],
  exports: [PriorityTagComponent, ChangePriorityModalComponent],
})
export class PriorityModule {}
